interface Translation {
    defaultLang: boolean;
    id?: string;
    lang: string;
}

export function findTrnaslation<T extends Translation>(
    data: T[],
    lang: string
) {
    const langMatch = data.find((d) => d.lang === lang);
    const defaultMatch = data.find((d) => d.defaultLang);
    return langMatch ? langMatch : defaultMatch;
}

export function getKeyInTranslation<T extends Translation>(
    data: T[],
    key: keyof Omit<T, keyof Translation>,
    lang: string
) {
    const langMatch = data.find((d) => d.lang === lang && d[key]);
    const defaultMatch = data.find((d) => d.defaultLang);

    return langMatch ? langMatch[key] : defaultMatch ? defaultMatch[key] : "";
}
